<template>
  <footer id="footer">
			<div class="footer-container">
				<router-link class="footer-logo" :to="{ name: 'HomeView' }"><img src="@/assets/logo.png" alt="おむすび家 とんじき"></router-link>
				<p id="footer-address" class="fltL">
					〒114-0002<br>
					東京都北区王子1-6-6<br>
					TEL：<a href="tel:090-3913-3283">090-3913-3283</a><br>
          FAX：03-6903-0213<br>
          ● 営業時間：5:00～16:00<br>（店舗受取は午前中のみ）<br>
          ● 定休日：毎週火曜日と12/29-1/5(臨時休業あり)<br>
				</p>
				<div id="footer-sns" class="footer-fltR">
          <a href="https://www.instagram.com/tonjiki.jp/">
            <img src="@\assets\Instagram_Glyph_Black.png" alt="INSTAGRAM">
          </a>
          <router-link :to="{ name: 'ContactForm' }">
            <img src="@/assets/mail_black.png" alt="とんじき">
          </router-link>
          <div></div>
				</div>
				<nav class="footer-nav">
					<router-link :to="{ name: 'MenuList' }">お品書き</router-link>
					<router-link :to="{ name: 'ContactForm' }">お問い合わせ</router-link>
				</nav>
			</div>
			<p class="copyright">© おむすび家 とんじき</p>
	</footer>
</template>

<script>
export default {
  name: "ShopFooter",
  setup() {
    return {};
  },
};
</script>
<style scoped>
#footer{
  position: relative;
  background:#1c1a17;
  color:#f6f0e6;
  border-top: 4px solid #9f3e32;
}
.footer-container {
    box-sizing: border-box;
    padding: 56px 32px 42px;
    width: min(1120px, 92%);
    max-width: none;
    margin: 0 auto;
    min-height: 1%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items:flex-start;
    gap:42px;
    & p {
    line-height: 1.75;
    font-weight: 550;
    }
    & a{
      color: #f6f0e6;
    }
}

.footer-container #footer-address {
    font-size: 13px;
    line-height: 1.8;
    margin: 0;
}
.footer-container #footer-sns {
    width: 189px;
  }
  .footer-fltR{
    & img{
      width: 30px;
      height: 30px;
      filter:invert(1);
    }
    margin: 1vw;
    justify-content: space-between;
    align-items: center;
    display: flex;
}
.footer-logo{width:130px;display:block}.footer-logo img{width:100%}.footer-nav{display:flex;flex-direction:column;gap:12px}.copyright{text-align:center;border-top:1px solid rgba(255,255,255,.12);padding:18px;font-size:11px;letter-spacing:.12em;color:#aaa}
@media(max-width:720px){.footer-container{width:100%;padding:40px 24px 32px;flex-direction:column;gap:26px}.footer-container #footer-address{font-size:13px;line-height:1.9}.footer-container #footer-sns{width:auto;margin:0;gap:24px;justify-content:flex-start}.footer-nav{width:100%;padding-top:22px;border-top:1px solid rgba(255,255,255,.12);flex-direction:row;flex-wrap:wrap;gap:16px 28px}.copyright{padding:16px 24px}}
</style>
